import {putMethod} from '~/api'

async function put(id, request) {
    return await putMethod(`/api/update/${id}`, request)
}

export {put}
